import { render, staticRenderFns } from "./ExternalPersonalInfo.vue?vue&type=template&id=da834e1a&scoped=true&"
import script from "./ExternalPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./ExternalPersonalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da834e1a",
  null
  
)

export default component.exports